import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth';
import { Administrators } from './routes/Administrators';
import { Clients } from './routes/Clients';
import { Login } from './routes/Login';
import { Logs } from './routes/Logs';
import { Retention } from './routes/Retention';
import { Settings } from './routes/Settings';

/**
 * The instance operator's console — the one surface that legitimately reads
 * across tenants. Split from the client portal (apps/web) so it can live on
 * its own origin, be firewalled separately, and never ship in the bundle every
 * client downloads. The API's @Roles('ADMIN') guard is the real boundary; this
 * app is the operator-shaped window onto it.
 */
export function App(): JSX.Element {
  const { user, ready, signOut } = useAuth();

  if (!ready) return <div className="main muted">Loading…</div>;
  if (!user) return <Login />;

  return (
    <div className="app">
      <aside className="sidebar">
        <h2>BidManager · Admin</h2>
        <nav className="nav">
          <NavLink to="/clients">Clients</NavLink>
          <NavLink to="/logs">Logs</NavLink>
          <NavLink to="/administrators">Administrators</NavLink>
          <NavLink to="/settings">Desktop version</NavLink>
          <NavLink to="/retention">Retention</NavLink>
        </nav>
        <button
          className="ghost sm"
          style={{ marginTop: 20, width: '100%' }}
          onClick={() => void signOut()}
        >
          Sign out
        </button>
      </aside>

      <main className="main">
        <Routes>
          <Route path="/" element={<Navigate to="/clients" replace />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/administrators" element={<Administrators />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/retention" element={<Retention />} />
          <Route path="*" element={<p className="muted">Not found.</p>} />
        </Routes>
      </main>
    </div>
  );
}
